import React from 'react'
import styled from '@emotion/styled'
import { TilesGroupTitle, TilesContainer } from './heroPanelStyles'

interface BannerTilesGroupProps {
  title?: string
  columnName?: string
  children?: React.ReactNode
}

const Container = styled.div`
  display: flex;
  flex-direction: column;
`

const TilesGroupTitleContainer = styled.div<{ rightAlign?: boolean }>`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  padding-right: 12px;
  margin-left: ${props => (props.rightAlign ? 'auto' : null)};
`

export const BannerTilesGroup: React.FunctionComponent<BannerTilesGroupProps> = props => (
  <Container>
    <TilesGroupTitleContainer rightAlign={props.columnName && !props.title ? true : false}>
      {props.title ? <TilesGroupTitle>{props.title}</TilesGroupTitle> : null}
      {props.columnName ? <TilesGroupTitle>{props.columnName}</TilesGroupTitle> : null}
    </TilesGroupTitleContainer>
    <TilesContainer>
      <div>{props.children}</div>
    </TilesContainer>
  </Container>
)
